.forgotPasswordForm {
  display: flex;
  flex-direction: column;
}
.forgotPasswordForm > * + * {
  margin-top: var(--cxy-spacing-xxsm);
}
.forgotPasswordForm .helperText {
  margin-bottom: var(--cxy-spacing-sm);
}
.forgotPasswordForm .buttonSection {
  padding-top: var(--cxy-spacing-xxsm);
  margin-bottom: 8rem;
}
.forgotPasswordForm .buttonSection button {
  text-transform: uppercase;
  width: 100%;
}

.responseMessage {
  margin-top: var(--cxy-spacing-xxxsm);
}

.errorMessage {
  color: var(--cxy-color-error);
}
